import tableRelatedSportRoomSponsor from './tableRelatedSportRoomSponsor';

export default {
  title: 'Sponsor',
  attributeName: 'sponsor',
  getURL: 'appId/sponsor',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  idAttribute:'contentId',
  sessionParams: ['appId'],
  tableConfig: tableRelatedSportRoomSponsor,
};
